import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import { alertError, alertSuccess } from 'store/ducks/alert'
import { intl } from 'i18n/index'
import { updateCalculatorConfig, fetchCalculatorConfigs } from 'store/services/profitability'

export const INIT = 'profitability/INIT'
export const INIT_SUCCESS = 'profitability/INIT_SUCCESS'
export const UPDATE = 'profitability/UPDATE'
export const UPDATE_SUCCESS = 'profitability/UPDATE_SUCCESS'

// Reducer
const INITIAL_STATE = {
  t1: '',
  t2: '',
  t3: '',
  basketPrimeAmount: '',
  nightPrimeAmount: '',
}

export function reducer(state = INITIAL_STATE, action = { type: INIT, payload: {} }) {
  switch (action.type) {
    case INIT:
      return state
    case INIT_SUCCESS:
      return { ...state, ...action.payload }
    case UPDATE:
      return { ...state, ...action.payload }

    default:
      return state
  }
}

export function fetchCalculatorConfigsAction() {
  return {
    type: INIT,
  }
}

export function fetchCalculatorConfigsActionSucces({ payload }) {
  return {
    type: INIT_SUCCESS,
    payload,
  }
}

export function updateCalculatorConfigAction({ payload }) {
  return {
    type: UPDATE,
    payload,
  }
}

export function updateCalculatorConfigSuccessAction({ payload }) {
  return {
    type: UPDATE_SUCCESS,
    payload,
  }
}

export function fetchCalculatorConfigsEpic(action$) {
  return action$.ofType(INIT).mergeMap(() => {
    return Observable.ajax(fetchCalculatorConfigs())
      .mergeMap((res) => Observable.of(fetchCalculatorConfigsActionSucces({ payload: res.response })))
      .catch(() => {
        return Observable.of(
          alertError(intl.formatMessage({ id: 'pages.profitability-calculation.configurator.fetch.error' })),
        )
      })
  })
}

export function updateCalculatorConfigsEpic(action$) {
  return action$.ofType(UPDATE).mergeMap((action) => {
    return Observable.ajax(updateCalculatorConfig(action.payload))
      .mergeMap((res) =>
        Observable.of(
          updateCalculatorConfigSuccessAction(res.response),
          alertSuccess(intl.formatMessage({ id: 'pages.profitability-calculation.configurator.update.success' })),
        ),
      )
      .catch(() =>
        Observable.of(
          alertError(intl.formatMessage({ id: 'pages.profitability-calculation.configurator.update.error' })),
        ),
      )
      .finally(() => Observable.of(fetchCalculatorConfigsAction()))
  })
}

export const epic = combineEpics(fetchCalculatorConfigsEpic, updateCalculatorConfigsEpic)
